module.exports = __webpack_public_path__ + "img/logo.75b4fca6.png";